import React from "react";
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import '../App.css';

const Header = () => {
    return (
        <nav className="modern-header" style={{ marginTop: isMobile ? "28px" : "" }}>
            <div className="header-content">
                <div className="header-left">
                    <img src="../logo.png" className="header-logo" alt="Logo"></img>
                </div>
                <div className="header-right">
                    <Link to={"/credit"} className="header-link credit-link">
                        <i className="bx bx-dollar"></i>
                        အကြွေး
                    </Link>
                    <Link to={"/app-download"} className="header-link app-link">
                        <i className="bx bx-cloud-download"></i>
                        App
                    </Link>
                    <a href="/" className="header-reload">
                        <i className="lni lni-reload"></i>
                    </a>
                </div>
            </div>
        </nav>
    );
}

export default Header;